import AuthenticationForm from "../../components/AuthenticationForm";
import Title from "../../components/Title";
import { RoutePages } from "../../ultils";

const AuthPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Title page={RoutePages.AUTH} title="Authentication" />
      <AuthenticationForm/>
    </div>
  );
};

export default AuthPage;
